export default (el) => {
  const isWpcFiltersSection = el.getElementsByClassName('wpc-filters-section')

  if (isWpcFiltersSection.length === 0) {
    el.classList.add('d-none')
  }
}
